const numberComma = (num) => {
  return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") : null;
};

export default numberComma;
